import * as v from 'valibot'

export const CLI_CLIENT_ID = 'voko-creator'
export const CLI_SCOPES = Object.freeze(['story:read', 'story:write', 'story:play', 'story:prepare'])
export const CliScopes = v.pipe(v.array(v.picklist(CLI_SCOPES)), v.minLength(1), v.maxLength(4), v.check(scopes => new Set(scopes).size === scopes.length, 'duplicate scope'))
export const CliUserCode = v.pipe(v.string(), v.regex(/^[A-F0-9]{5}-[A-F0-9]{5}$/))
const Secret = v.pipe(v.string(), v.minLength(32), v.maxLength(150))
export const CliDeviceRequest = v.strictObject({ client_id: v.literal(CLI_CLIENT_ID), scopes: CliScopes })
export const CliDeviceResponse = v.object({
  device_code: Secret, user_code: CliUserCode,
  verification_uri: v.pipe(v.string(), v.url()), verification_uri_complete: v.pipe(v.string(), v.url()),
  expires_in: v.number(), interval: v.number(),
})
export const CliAuthorizationView = v.object({
  client_id: v.literal(CLI_CLIENT_ID), client_name: v.string(), scopes: CliScopes,
  user_code: CliUserCode, status: v.picklist(['pending', 'approved', 'denied', 'consumed', 'expired']), expires_at: v.string(),
})
export const CliAuthorizationDecision = v.strictObject({ decision: v.picklist(['approve', 'deny']) })
export const CliTokenRequest = v.union([
  v.strictObject({ grant_type: v.literal('urn:ietf:params:oauth:grant-type:device_code'), client_id: v.literal(CLI_CLIENT_ID), device_code: Secret }),
  v.strictObject({ grant_type: v.literal('refresh_token'), client_id: v.literal(CLI_CLIENT_ID), refresh_token: Secret }),
])
export const CliTokens = v.object({
  status: v.literal('authorized'), account: v.object({ id: v.string() }),
  access_token: Secret, refresh_token: Secret, expires_in: v.number(), grant_id: v.pipe(v.string(), v.uuid()), scopes: CliScopes,
})
export const CliTokenResponse = v.union([
  CliTokens,
  v.object({ status: v.picklist(['authorization_pending', 'access_denied', 'expired_token', 'invalid_grant', 'slow_down']), interval: v.number() }),
])
export const CliRevokeRequest = v.strictObject({ refresh_token: Secret })
export const CliGrantView = v.object({
  id: v.pipe(v.string(), v.uuid()), client_name: v.string(), scopes: CliScopes,
  status: v.picklist(['active', 'revoked', 'expired']), created_at: v.string(), expires_at: v.string(), revoked_at: v.nullable(v.string()),
})
export const CliGrantList = v.object({ items: v.array(CliGrantView) })
export const CliRevoked = v.object({ revoked: v.literal(true) })

export const parseCliScopes = value => v.parse(CliScopes, value)
export const parseCliDeviceResponse = value => v.parse(CliDeviceResponse, value)
export const parseCliAuthorizationView = value => v.parse(CliAuthorizationView, value)
export const parseCliTokenResponse = value => v.parse(CliTokenResponse, value)
export const parseCliGrantList = value => v.parse(CliGrantList, value)
export const parseCliRevoked = value => v.parse(CliRevoked, value)
